import { useState } from "react";
import "./EditarBannerCategoria.css";

function EditarBannerCategoria({
  banner,
  onClose,
  onSalvar,
}) {
  const [arquivo, setArquivo] =
    useState(null);

  const [preview, setPreview] =
    useState(null);

  const [salvando, setSalvando] =
    useState(false);

  const handleSelecionarImagem = (
    e
  ) => {
    const file =
      e.target.files?.[0];

    if (!file) return;

    setArquivo(file);

    const reader =
      new FileReader();

    reader.onload = (
      event
    ) => {
      setPreview(
        event.target.result
      );
    };

    reader.readAsDataURL(file);
  };

  const handleSalvar =
    async () => {
      if (!arquivo) {
        alert(
          "Selecione uma imagem."
        );
        return;
      }

      try {
        setSalvando(true);

        const formData =
          new FormData();

        formData.append(
          "imagem",
          arquivo
        );

        const uploadResponse =
          await fetch(
            "https://app.eliandroalimentos.com.br/api/imagem/upload",
            {
              method: "POST",
              body: formData,
            }
          );

        const uploadData =
          await uploadResponse.json();

        if (
          !uploadResponse.ok
        ) {
          throw new Error(
            uploadData.message ||
              "Erro ao fazer upload"
          );
        }

        const editarResponse =
          await fetch(
            "https://app.eliandroalimentos.com.br/api/home_media/editarimagembanner",
            {
              method: "PUT",
              headers: {
                "Content-Type":
                  "application/json",
              },
              body: JSON.stringify(
                {
                  id: banner.id,
                  imagem:
                    uploadData.caminho,
                }
              ),
            }
          );

        const editarData =
          await editarResponse.json();

        if (
          !editarResponse.ok ||
          !editarData.success
        ) {
          throw new Error(
            editarData.message ||
              "Erro ao atualizar banner"
          );
        }

        onSalvar?.({
          ...banner,
          imagem:
            uploadData.caminho,
        });

        onClose();
      } catch (error) {
        console.error(error);

        alert(
          error.message ||
            "Erro ao atualizar banner"
        );
      } finally {
        setSalvando(false);
      }
    };

  return (
    <div
      className="AdminCategoriaBanner-overlay"
      onClick={onClose}
    >
      <div
        className="AdminCategoriaBanner-container"
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <div className="AdminCategoriaBanner-header">
          <h2>
            Editar Banner{" "}
            {banner.ordem}
          </h2>

          <button
            className="AdminCategoriaBanner-fechar"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className="AdminCategoriaBanner-conteudo">

          <div className="AdminCategoriaBanner-bloco">
            <h3>
              Imagem Atual
            </h3>

            <div className="AdminCategoriaBanner-previewBanner">
              <img
                src={
                  banner.imagem
                }
                alt=""
              />
            </div>
          </div>

          <div className="AdminCategoriaBanner-bloco">
            <h3>
              Nova Imagem (1654 × 827 px) .jpg
            </h3>

            <input
              type="file"
              accept="image/*"
              onChange={
                handleSelecionarImagem
              }
            />

            {preview && (
              <div className="AdminCategoriaBanner-previewOriginal">
                <img
                  src={preview}
                  alt=""
                />
              </div>
            )}
          </div>

          {preview && (
            <div className="AdminCategoriaBanner-bloco">
              <h3>
                Como ficará
              </h3>

              <div className="AdminCategoriaBanner-previewBanner">
                <img
                  src={preview}
                  alt=""
                />
              </div>
            </div>
          )}
        </div>

        <div className="AdminCategoriaBanner-footer">
          <button
            className="AdminCategoriaBanner-btnCancelar"
            onClick={onClose}
          >
            Cancelar
          </button>

          <button
            className="AdminCategoriaBanner-btnSalvar"
            onClick={
              handleSalvar
            }
            disabled={
              salvando
            }
          >
            {salvando
              ? "Salvando..."
              : "Salvar"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditarBannerCategoria;